import React, { useState, useContext, useEffect } from 'react';
import { Button, Table, Input, PageHeader, Space, message, Modal, Switch, Tag, Tooltip } from 'antd';
import { CopyOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import MainLayout from '../../common/layout';
import { Link } from 'react-router-dom';
import { withApollo } from '@apollo/react-hoc';
import { AuthContext } from '../../../context/authContext';
import { listOrderSetByCreatedAt } from '../../../graphql/queries';
import { updateOrderSet } from '../../../graphql/mutations';
import moment from 'moment'
import OrdersetPreview from './ordersetPreview';
import GroupUpdate from './groupUpdate';

const listOrderSetByCreatedAtQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: listOrderSetByCreatedAt,
      variables: variables,
      fetchPolicy: 'no-cache'
    }).then((data) => {
      res(data)
    }).catch((err) => {
      console.log(err)
      rej(err)
    })
  })
}

const updateOrderSetMut = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.mutate({
      mutation: updateOrderSet,
      variables: variables
    }).then((data) => {
      res(data)
    }).catch((err) => {
      rej(err)
    })
  })
}

const ManageOrdersets = (props) => {
  const context = useContext(AuthContext);

  const [loading, setloading] = useState(false);
  const [data, setdata] = useState([]);
  const [searchedData, setsearchedData] = useState([])
  const [visible, setvisible] = useState(false);
  const [selected, setselected] = useState(null);
  const [searched, setsearched] = useState(false);
  const [query, setquery] = useState('');
  const [groupedData, setgroupedData] = useState(null);
  const [userArr, setuserArr] = useState({ createdBy: [], updatedBy: [] })
  const [selectedGroup, setselectedGroup] = useState(null)
  const [groupUpdate, setgroupUpdate] = useState(false)
  const [updateList, setupdateList] = useState(false)
  const [nextToken, setnextToken] = useState(null)



  useEffect(() => {
    let userArr1 = { createdBy: [], updatedBy: [] };
    data.forEach((a) => {
      if (userArr1.createdBy.includes(a.createdBy) == false) {
        userArr1.createdBy.push(a.createdBy)
      }

      if (a.updatedBy && userArr1.updatedBy.includes(a.updatedBy) == false) {
        userArr1.updatedBy.push(a.updatedBy)
      }
    })
    setuserArr(userArr1)

  }, [data])


  // useEffect(() => {
  //   getOrderSets()
  // }, [updateList]);

  useEffect(() => {
    getOrderSets()
  }, []);

  //================================= orderset disable - (dont have any dependency)
  const handleOrdersetStatusUpdate = (checked, record) => {
    setloading(true)
    let variables = {
      typeValue: record.typeValue,
      slugValue: record.slugValue,
      orderSetName: record.orderSetName,
      searchField: record.searchField,
      diagnosis: record.diagnosis,
      active: checked
    }
    updateOrderSetMut(props, variables)
      .then(({ data }) => {

        setloading(false)
        if (data.updateOrderSet) {
          message.success('Updated Successfully')
          getOrderSets()
        }
      }).catch((err) => {
        console.log(err)
        setloading(false)
        message.error('There is some error')
      })
  }

  const ordersetPagination=(token, stage, arr)=>{

    return new Promise((resolve,reject)=>{
      let variables = {
        limit: 500,
        stage: stage,
        nextToken: token
      };
      listOrderSetByCreatedAtQuery(props, variables)
        .then(async(res) => {
          arr = [...arr, ...res.data.listOrderSetByCreatedAt.items];
          if(res.data.listOrderSetByCreatedAt.nextToken == null){
            // console.log('//',arr)
            resolve(arr)
          }
          else{
            let res1 = await ordersetPagination(res.data.listOrderSetByCreatedAt.nextToken,stage, arr)
            resolve(res1)
          }
        })
        .catch((err)=>{
          console.log(err)
          reject(err)
        })

    })
  }

  const getOrderSets = async() => {
    setloading(true)
    let env = { 'development': 'dev', 'testing': 'QA', 'production': 'prod' };
    let stage = env[process.env.REACT_APP_NODE_ENV];

    let variables = {
      limit: 500,
      stage: stage
    };
    try{
      let res = await ordersetPagination(undefined, stage,[]);

      if (res.length > 0) {
        let obj = new Object();
        let arr = []
        res.map((a) => {
          if (obj.hasOwnProperty(a.orderSetName)) {
            a.key = a.diagnosis;
            obj[a.orderSetName].push(a);
            let index = arr.findIndex((item) => item.title == a.orderSetName);
            let item = arr[index];

            if (item) {
              item.group.push(a)
              item.diagnosisSet.push(`${a.diagnosis} - ${a.diagnosisMap ? a.diagnosisMap.name : ''}`)
              if(item.createdBy.indexOf(a.createdBy) == -1){
                item.createdBy.push(a.createdBy)
              }
              if(item.updatedBy.indexOf(a.updatedBy) == -1){
                item.updatedBy.push(a.updatedBy)
              }
              arr.splice(index, 1, item)
            }

          } else {

            obj[a.orderSetName] = [a];
          
            arr.push({
              createdBy: [a.createdBy],
              updatedBy: [a.updatedBy],
              title: a.orderSetName,
              group: [a],
              key: a.orderSetName,
              diagnosisSet: [`${a.diagnosis} - ${a.diagnosisMap ? a.diagnosisMap.name : ''}`]
            })
          }
        })

        setgroupedData(arr)
        setdata(res);
        if(searched == true){
          let arr1 = arr.filter((item) => {
            let filters = item.diagnosisSet.filter((a) => {
              if (a.trim().toLowerCase().indexOf(query.trim().toLowerCase()) != -1) {
                return a
              }
            });
    
            if (
              item.title.trim().toLowerCase().indexOf(query.trim().toLowerCase()) != -1
              ||
              filters.length > 0
            ) {
              return item
            }
          })
          setsearchedData(arr1)
        }
      }
      setloading(false)
    }catch(err){
      console.log(err)
    }
    return
    listOrderSetByCreatedAtQuery(props, variables)
      .then((res) => {
        if (res.data && res.data.listOrderSetByCreatedAt && res.data.listOrderSetByCreatedAt != null) {
          let obj = new Object();
          let arr = []
          res.data.listOrderSetByCreatedAt.items.map((a) => {
            if (obj.hasOwnProperty(a.orderSetName)) {
              a.key = a.diagnosis;
              obj[a.orderSetName].push(a);
              let index = arr.findIndex((item) => item.title == a.orderSetName);
              let item = arr[index];

              if (item) {
                item.group.push(a)
                item.diagnosisSet.push(`${a.diagnosis} - ${a.diagnosisMap ? a.diagnosisMap.name : ''}`)
                arr.splice(index, 1, item)
              }

            } else {

              obj[a.orderSetName] = [a];
              arr.push({
                title: a.orderSetName,
                group: [a],
                key: a.orderSetName,
                diagnosisSet: [`${a.diagnosis} - ${a.diagnosisMap ? a.diagnosisMap.name : ''}`]
              })
            }
          })

          setgroupedData(arr)
          setdata(res.data.listOrderSetByCreatedAt.items);
          if(searched == true){
            let arr1 = arr.filter((item) => {
              let filters = item.diagnosisSet.filter((a) => {
                if (a.trim().toLowerCase().indexOf(query.trim().toLowerCase()) != -1) {
                  return a
                }
              });
      
              if (
                item.title.trim().toLowerCase().indexOf(query.trim().toLowerCase()) != -1
                ||
                filters.length > 0
              ) {
                return item
              }
            })
            setsearchedData(arr1)
          }
        }
        setloading(false)
      }).catch((err) => {
        setloading(false)
        console.log(err)
      })
  }

  const columns = [
    {
      title: 'Order Set Name',
      key: 'orderSetName',
      dataIndex: 'orderSetName'
    },
    {
      title: 'Diagnosis',
      key: 'diagnosis',
      dataIndex: 'diagnosis',
      render: (text, record) => {
        return `${text} - ${record.diagnosisMap ? record.diagnosisMap.name : ''}`
      }
    },
    {
      title: 'Created By',
      dataIndex: 'createdBy',
      key: 'createdBy',
      render: (text, record) => {
        return (<div>
          <p style={{ marginBottom: '0px', fontSize: '13px' }}>{text && text != null ? text : '-'}</p>
          <p style={{ marginBottom: '0px', fontSize: '13px' }}>{record.createdAt && record.createdAt != null ? moment.unix(record.createdAt).format('DD-MM-YYYY') : '-'}</p>
        </div>)
      },
      // filters: userArr.createdBy.map((a) => {
      //   return {
      //     text: a,
      //     value: a,
      //   }
      // }),
      // onFilter: (value, record) => record.createdBy == value,
    },
    {
      title: 'Updated By',
      dataIndex: 'updatedBy',
      key: 'updatedBy',
      render: (text, record) => {
        return (<div>
          <p style={{ marginBottom: '0px', fontSize: '13px' }}>{text && text != null ? text : '-'}</p>
          <p style={{ marginBottom: '0px', fontSize: '13px' }}>{record.updatedAt && record.updatedAt != null ? moment.unix(record.updatedAt).format('DD-MM-YYYY') : '-'}</p>
        </div>)
      },
      // filters: userArr.updatedBy.map((a) => {
      //   return {
      //     text: a,
      //     value: a,
      //   }
      // }),
      // onFilter: (value, record) => record.updatedBy == value,
    },
    // {
    //   title: 'Age Group',
    //   dataIndex: 'ageGroup',
    //   key: 'ageGroup',
    //   render:(text, record)=>{
    //     text = ''

    //     if(record.ageGroup){
    //       text = record.ageGroup.map((a)=>`${a.type} ${a.ageFrom} ${a.ageTo}`).join(' ')
    //     }

    //     return (<div>
    //       <p style={{marginBottom:'5px'}}>{text ? text : '-'}</p>
    //       {record.appliedFor ? record.appliedFor : ''}
    //   </div>)
    //   },
    // },
    {
      title: 'Status',
      dataIndex: 'active',
      key: 'active',
      width: '15%',
      render: (text, record) => {
        return <>
          <Switch size="small" checked={record.active} onChange={(checked) => {
            handleOrdersetStatusUpdate(checked, record)
          }} />
        </>
      }
    },
    {
      title: 'Actions',
      dataIndex: 'preview',
      key: 'preview',
      render: (text, record) => {
        return (
          <Space>
            <Link to={{
              pathname: `/createOrdersets`,
              state: { record: record }
            }}>
              <Tooltip placement="topLeft" title={'Edit'}>
                <Button type="link" target="__blank">
                  <EditOutlined />
                </Button>

              </Tooltip>
            </Link>
            <Tooltip placement="topLeft" title={'Preview'}>
              <Button type="link"
                onClick={() => {
                  setselected(record)
                  setvisible(true)
                }}><EyeOutlined /></Button>
            </Tooltip>

            <Link to={{
              pathname: `/createOrdersets`,
              state: { record: { action: 'clone', ...record } }
            }}>
              <Tooltip placement="topLeft" title={'Copy'}>

                <Button type="link" target="__blank">
                  <CopyOutlined />
                </Button>
              </Tooltip>
            </Link>
          </Space>
        )
      },
    }
  ];


  const handleSearch = (val, type) => {
    if (val == '') {
      setsearched(false)
      setquery('')
    } else {

      let arr = groupedData.filter((item) => {
        let filters = item.diagnosisSet.filter((a) => {
          if (a.trim().toLowerCase().indexOf(val.trim().toLowerCase()) != -1) {
            return a
          }
        });

        if (
          item.title.trim().toLowerCase().indexOf(val.trim().toLowerCase()) != -1
          ||
          filters.length > 0
        ) {
          return item
        }
      })
      setsearchedData(arr)
      setsearched(true)
      setquery(val)
    }
  }


  const expandedRowRender = (res) => {
    return <Table style={{ width: '100%' }} size="small" bordered columns={columns} dataSource={res.group} pagination={false} />;
  }

  const groupedColumns = [
    {
      title: 'Order Set Name',
      key: 'title',
      dataIndex: 'title',
      width: '150px'
    },
    {
      title: 'Entries Count',
      key: 'diagnosisSet',
      dataIndex: 'diagnosisSet',
      width: '50px',
      render: (text, record) => {
        return (
          text.length
        )
      }
    },
    {
      title: 'Diagnosis',
      key: 'diagnosisSet',
      dataIndex: 'diagnosisSet',
      width: '300px',
      render: (text, record) => {
        return (
          text.map((a) => {
            return <>
            <Tag style={{ marginBottom: '4px', fontSize: '11px', lineHeight: '20px' , wordBreak: 'break-word',  // Ensures long words break into the next line
  overflowWrap: 'break-word', // Alternative way to handle long words
  whiteSpace: 'normal'}}>{a}</Tag>
            <br></br>
            </>
          })
        )
      }
    },
    {
      title: 'Created By',
      dataIndex: 'createdBy',
      key: 'createdBy',
      width: '50px',
      render: (text, record) => {
        return (<div>
          <p style={{ marginBottom: '0px', fontSize: '10px' }}>{text && text != null ? text.join(', ') : '-'}</p>
          {/* <p style={{ marginBottom: '0px', fontSize: '13px' }}>{record.createdAt && record.createdAt != null ? moment.unix(record.createdAt).format('DD-MM-YYYY') : '-'}</p> */}
        </div>)
      },
      filters: userArr.createdBy.map((a) => {
        return {
          text: a,
          value: a,
        }
      }),
      onFilter: (value, record) => record.createdBy.indexOf(value) >-1,
    },
    {
      title: 'Updated By',
      dataIndex: 'updatedBy',
      key: 'updatedBy',
      width: '50px',
      render: (text, record) => {
        return (<div>
          <p style={{ marginBottom: '0px', fontSize: '10px' }}>{text && text != null ? text.join(', ') : '-'}</p>
          {/* <p style={{ marginBottom: '0px', fontSize: '13px' }}>{record.updatedAt && record.updatedAt != null ? moment.unix(record.updatedAt).format('DD-MM-YYYY') : '-'}</p> */}
        </div>)
      },
      filters: userArr.updatedBy.map((a) => {
        return {
          text: a,
          value: a,
        }
      }),
      onFilter: (value, record) => record.updatedBy.indexOf(value) >-1,

    },
    {
      title: 'Actions',
      key: 'actions',
      width: '100px',
      dataIndex: 'actions',
      render: (text, record) => {

        return (
          <Space>
            <Tooltip placement="topLeft" title={'Edit'}>
              <Button type="link" onClick={() => {
                setselectedGroup(record)
                setgroupUpdate(true)
              }}>
                <EditOutlined />
              </Button>

            </Tooltip>
          </Space>
        )
      }
    }
  ]

  return (
    <MainLayout >
      <PageHeader
        ghost={false}
        title={'Manage Order sets'}
        subTitle={`Total Count: ${data.length}`}
        extra={[
          <Input.Search
            // enterButton
            placeholder="Search"
            style={{ width: 350 }}
            onChange={(e) => {
              let val = e.target.value;
              handleSearch(val, 'form')
            }}
          />,
          <Link to="/createOrdersets">
            <Button id='createOrderSetPageBtn' type="primary" >Create</Button>
          </Link>
        ]}
      >

      </PageHeader>

      <Table
        size="small"
        style={{ width: '100%',marginTop: 20 }}
        expandable={{ expandedRowRender }}
        dataSource={
          searchedData.length > 0 && searched == true ?
            searchedData : searchedData.length == 0 && searched == true ?
              [] :
              groupedData != null ?
                groupedData.sort() : []
        }
        columns={groupedColumns}
      
        loading={loading}
        pagination={true} />

      {selected != null &&
        <Modal
          title={`${selected.orderSetName}`}
          // maskClosable={false}
          visible={visible}
          onOk={() => {
            setvisible(false)
          }}
          onCancel={() => {
            setvisible(false)
          }}
          destroyOnClose
          width={'60%'}
          footer={false}
        >
          <OrdersetPreview record={selected} />
        </Modal>
      }

      {selectedGroup != null &&
        <Modal
          title={`${selectedGroup.title}`}
          // maskClosable={false}
          visible={groupUpdate}
          onOk={() => {
            setgroupUpdate(false)
            setselectedGroup(null)

          }}
          onCancel={() => {
            setgroupUpdate(false)
            setselectedGroup(null)

          }}
          destroyOnClose
          width={'60%'}
          footer={false}
        >
          <GroupUpdate selectedGroup={selectedGroup} updateMainList={()=>{
            setupdateList(!updateList)
          }}/>

        </Modal>
      }

    </MainLayout>
  )
}

export default withApollo(ManageOrdersets)